import { API_TYPE } from '@umu/umu-fetch';
const BASE = '/uapi/v1';

export const USEAPI = {
    USE_MY_DEPARTMENT: {
        url: `${BASE}/enterprise/my-se-department`,
        type: API_TYPE.GET,
    },
};
